var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthsensorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.322632,
    y: 0.815002,
    width: 10.5326,
    height: 10.4066,
    rx: 5.20331,
    stroke: "currentColor",
    strokeWidth: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.57263 6.42727H3.01044C3.05532 6.42727 3.09471 6.45717 3.10677 6.5004L3.74238 8.77877C3.77189 8.88453 3.92557 8.87236 3.93806 8.76327L4.52563 3.62922C4.53915 3.51111 4.71068 3.51102 4.72432 3.62912L5.15666 7.37302C5.16831 7.47391 5.30552 7.4952 5.3472 7.40258L5.72512 6.56276C5.76544 6.47315 5.89729 6.48935 5.91472 6.58605L6.27882 8.60594C6.29832 8.71413 6.45275 8.7162 6.47514 8.60857L7.35601 4.3744C7.37762 4.2705 7.52487 4.26738 7.55086 4.37028L8.01136 6.19308C8.02258 6.23747 8.06252 6.26858 8.10831 6.26858H9.60521",
    stroke: "currentColor",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthsensorIcon);
export default __webpack_public_path__ + "static/media/healthsensorIcon.13e0dc0d5f39c1480970d9ed7b7a73d4.svg";
export { ForwardRef as ReactComponent };